export const idx_data_ball_speed = [];

idx_data_ball_speed.push({
  speed: '',
  order_idx: -1,
});

idx_data_ball_speed.push({
  speed: 'High',
  order_idx: 0,
});

idx_data_ball_speed.push({
  speed: 'Medium',
  order_idx: 1,
});

idx_data_ball_speed.push({
  speed: 'Low',
  order_idx: 2,
});
